<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div
    class="rounded-md bg-red-50 p-4"
    v-if="errors_data.display"
    :id="id ? id : 'standard_error_messages_alert'"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <i
          class="fa-solid fa-circle-xmark h-5 w-5 text-red-400"
          aria-hidden="true"
        ></i>
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-red-800">
          {{ errors_data.title }}
        </h3>

        <div
          v-if="errors_data.message || errors_data.messages?.length > 0"
          class="mt-2 text-sm text-red-700"
        >
          <p v-if="errors_data.message">{{ errors_data.message }}</p>
          <ul
            v-if="errors_data.messages.length > 0"
            role="list"
            class="list-disc pl-5 space-y-1"
          >
            <li
              v-for="(message_item, index_item) in errors_data.messages"
              :key="index_item"
            >
              {{ message_item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertDanger",
  components: {},
  props: ["id", "errors_data"],
  data() {
    return {};
  },
};
</script>